function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchPolizaComments, createPolizaComment, updatePolizaComment, deletePolizaComment, getIndexQueryKey } from "./actions/PolizaCommentActions";
import { getVersionsQueryKey } from "./actions/BitacoraVersionActions";
import CommentItem from "./CommentItem";
import CommentForm from "./CommentForm";

var CommentsSection = function CommentsSection(props) {
  var polizaId = props.polizaId,
      admin = props.admin,
      token = props.token;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editingComment = _React$useState2[0],
      setEditingComment = _React$useState2[1];

  var queryClient = useQueryClient();
  var indexQueryKey = getIndexQueryKey(polizaId);

  var _useQuery = useQuery({
    queryKey: indexQueryKey,
    queryFn: function queryFn() {
      return fetchPolizaComments(polizaId);
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 30000
  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      error = _useQuery.error;

  var refreshList = function refreshList() {
    queryClient.invalidateQueries({
      queryKey: indexQueryKey
    }); // También refrescar el historial de versiones

    queryClient.invalidateQueries({
      queryKey: getVersionsQueryKey(polizaId)
    });
  };

  var handleCreate = function handleCreate(formData) {
    createPolizaComment({
      poliza_id: polizaId,
      content: formData.content,
      management_type: formData.management_type,
      contact_method: formData.contact_method,
      next_step: formData.next_step,
      status: formData.status
    }, token).then(function () {
      refreshList();
    })["catch"](function (error) {
      var _error$response;

      console.error("Error creating comment:", error);
      console.error("Error details:", (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data);
      alert("Error al crear el comentario. Por favor, intenta de nuevo.");
    });
  };

  var handleUpdate = function handleUpdate(id, formData) {
    updatePolizaComment({
      id: id,
      content: formData.content,
      management_type: formData.management_type,
      contact_method: formData.contact_method,
      next_step: formData.next_step,
      status: formData.status
    }, token).then(function () {
      refreshList();
      setEditingComment(null);
    })["catch"](function (error) {
      var _error$response2;

      console.error("Error updating comment:", error);
      console.error("Error details:", (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data);
      alert("Error al actualizar el comentario. Por favor, intenta de nuevo.");
    });
  };

  var handleDelete = function handleDelete(id) {
    if (confirm("¿Está seguro de eliminar este comentario?")) {
      deletePolizaComment(id).then(function () {
        refreshList();
      })["catch"](function (error) {
        console.error("Error deleting comment:", error);
        alert("Error al eliminar el comentario. Por favor, intenta de nuevo.");
      });
    }
  };

  var comments = (data === null || data === void 0 ? void 0 : data.poliza_comments) || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "comments-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      marginBottom: "0",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header",
    style: {
      padding: "10px 15px",
      backgroundColor: "#f8f9fa",
      borderBottom: "1px solid #dee2e6"
    }
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600"
    }
  }, "Comentarios")), /*#__PURE__*/React.createElement("div", {
    className: "card-body",
    style: {
      padding: "12px",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement(CommentForm, {
    onSubmit: editingComment ? function (formData) {
      return handleUpdate(editingComment.id, formData);
    } : handleCreate,
    initialData: editingComment ? {
      content: editingComment.content,
      management_type: editingComment.management_type,
      contact_method: editingComment.contact_method,
      next_step: editingComment.next_step,
      status: editingComment.status
    } : undefined,
    onCancel: editingComment ? function () {
      return setEditingComment(null);
    } : undefined
  }), isLoading && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "13px",
      margin: "10px 0",
      color: "#666"
    }
  }, "Cargando comentarios...")), !isLoading && comments.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "15px",
      flex: 1,
      overflowY: "auto",
      maxHeight: "400px"
    }
  }, comments.map(function (comment) {
    return /*#__PURE__*/React.createElement(CommentItem, {
      key: comment.id,
      comment: comment,
      admin: admin,
      onEdit: function onEdit() {
        return setEditingComment(comment);
      },
      onDelete: function onDelete() {
        return handleDelete(comment.id);
      }
    });
  })))));
};

export default CommentsSection;